import React from 'react';
import ReactDOM from 'react-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';

import App from './App';
import reportWebVitals from './reportWebVitals';
import './utils/firebase';

import { store } from './redux/store';
import Error from './components/Error';
import { getPrivateBrandingConfig } from './config/privateBooking';

const applyBranding = (): void => {
  const branding = getPrivateBrandingConfig();
  const resolveAssetPath = (assetPath: string): string => {
    if (/^https?:\/\//i.test(assetPath)) {
      return assetPath;
    }
    const publicUrl = process.env.PUBLIC_URL ?? '';
    if (!publicUrl) {
      return assetPath.startsWith('/') ? assetPath : `/${assetPath}`;
    }
    if (assetPath.startsWith('/')) {
      return `${publicUrl}${assetPath}`;
    }
    return `${publicUrl}/${assetPath}`;
  };

  document.title = branding.pageTitle;
  const faviconHref = resolveAssetPath(branding.faviconPath);
  const updateLinkHref = (rel: string) => {
    const selector = `link[rel="${rel}"]`;
    let link = document.querySelector<HTMLLinkElement>(selector);
    if (!link) {
      link = document.createElement('link');
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.href = faviconHref;
  };

  updateLinkHref('icon');
  updateLinkHref('shortcut icon');
  updateLinkHref('apple-touch-icon');
};

applyBranding();

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={Error}>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
